import { render, staticRenderFns } from "./COIRequests.vue?vue&type=template&id=45972bec&scoped=true&"
import script from "./COIRequests.vue?vue&type=script&lang=js&"
export * from "./COIRequests.vue?vue&type=script&lang=js&"
import style0 from "./COIRequests.vue?vue&type=style&index=0&id=45972bec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45972bec",
  null
  
)

export default component.exports